<template>
  <div>
    <div class="col-sm-12 forms-sample m-0" style="padding-bottom: 60px; border-radius: 10px; border: 1px solid #dcdcdc6e">
      <h6 class="sub-title mb-3 color-default font-weight-bold">
        {{ formHeader }}
      </h6>
      <div class="alert alert-warning" style="display: none">
        <strong>Heads up!</strong> This will send an email to every
        organization's main email with given subject and message.
      </div>
      <b-row v-if="isLoader">
        <b-col cols="12">
          <b-skeleton-img no-aspect height="50px" width="65%"></b-skeleton-img>
        </b-col>
        <b-col cols="12">
          <b-skeleton-img no-aspect height="150px" ></b-skeleton-img>
        </b-col>
      </b-row>
      <div v-show="!isLoader">
      <div class="col-12 ">
        <div class="col-6 px-0">
          <input type="hidden" name="notification_id" v-model="notification_id" />
          <label class="label-form">Subject</label>
          <input type="text" class="form-control" rows="3" style="width: 100%; border-radius:0.1rem !important;" v-model="subject"
            placeholder="subject of notification.."></input>

            <div class="mt-2">
                <label for="notification">Upload Image:</label><br>
                <div class="row">
                    <div class="col-md-6 mt-3">
                    <input
                      style="border: 1px solid #d4cfcf; padding: 8px; height: 50px; width: inherit"
                      type="file"
                      @change="handleFileUpload"
                    />
                </div>
                  <div v-if="previous_image" class="col-md-6">
                    <a :href="previous_image" target="_blank">
                      <img :src="previous_image" alt="Selected File" class="previous_image"/>
                    </a>
                  </div>
                </div>
            </div>




        </div>
        <div class="col-12 px-0 pt-0">
          <label class="label-form">Body</label>
          <tiny-mce-editor :vModelName.sync="body"></tiny-mce-editor>
        </div>
        <!-- <button @click="sendNotification" style="float: right;" class="btn btn-primary">Send</button> -->
        <div class="row">
          <div class="col-md-3" style="padding-top: 20px">
            <input type="radio" id="radio_email" class="ml-2" :style="[is_edit && $route.fullPath != '/notifications/new'?{'pointer-events':'none'}:{'pointer-events':'auto'}]" data-toggle="modal" @click="check($event, 0)"
              value="0" v-model="onlyMail" />
            <span class="checkmark ml-1"></span>
            <label for="radio_email" :style="[is_edit && $route.fullPath != '/notifications/new'?{'pointer-events':'none'}:{'pointer-events':'auto'}]"> Only Send Email</label>
          </div>
          <div class="col-md-3" style="padding-top: 20px">
            <input type="radio" id="radio_notification" style="cursor: pointer" data-toggle="modal" @click="check($event, 1)" value="1"
              v-model="onlyMail" />
            <span class="checkmark ml-1"></span>
            <label for="radio_notification"> Only Notification</label>
          </div>

          <div class="col-md-3" style="padding-top: 20px">
            <input type="radio" id="radio_email_notification" :style="[is_edit && $route.fullPath != '/notifications/new'?{'pointer-events':'none'}:{'pointer-events':'auto'}]" data-toggle="modal" @click="check($event, 2)" value="2"
              v-model="onlyMail" />
            <span class="checkmark ml-1"></span>
            <label for="radio_email_notification":style="[is_edit && $route.fullPath != '/notifications/new'?{'pointer-events':'none'}:{'pointer-events':'auto'}]">Both Email & Notification</label>
          </div>
        </div>
       </div>
      <br />
      <div v-if="is_show_mail_table && $route.fullPath == '/notifications/new'">

      <!-- filters -->
      <div class="row">
        <!-- <div class="col-4 px-5">
          <label>Type</label>
          <select v-on:change="changeType($event)" class="demo-date form-control" v-model="selectedType">
            <option value="">All</option>-->
            <!-- <option value="0">Admin</option> -->
            <!-- <option value="10">Customers</option>
            <option value="6">Drivers</option> -->
            <!-- <option value="3">Manager</option>
            <option value="9">Production Supervisor</option> -->
            <!-- <option value="4">Shipping &amp; Receiving</option> -->
          <!-- </select>
        </div> --> 
        <div class="col-3 px-4" >
          <label>Type</label>
          <multiselect  @input="changeType($event)" placeholder='All' :multiple="true"  :options="type_filter" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="selectedType"
          label="name" track-by="id" style="font-size:12px !important">
          </multiselect>
          <!-- <select v-on:change="shortTerm($event)" class="form-control demo-date" v-model="select_followUp">
            <option class="dropdown-item" value="all">All</option>
            <option class="dropdown-item" value="0">Short Term Followups</option>
            <option class="dropdown-item" value="1">Long Term Followups</option>
          </select> -->
        </div>
        <div class="col-9 px-3">
          <!-- Search -->
          <div class="col-3 py-0 float-right">
            <div class="" ref="formContainer">
              <label for="">Search</label>
              <div class="has-search">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="text" v-model="search" @keyup="subscribedUsersBySearch" style="background-color: #edf2f5; border-radius:0.1rem !important;"
                  class="form-control" placeholder="Search Here..." />
                  <!-- <font-awesome-icon v-if="isMiniLoading2" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 0px; margin-top: -26px; margin-right:15px;" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
       <table class="table table-hover text-center table-width"  id="dataTable">
        <thead>
          <tr class="text-left">
            <th></th>
            <th>Company</th>
            <th>Role</th>
            <th>Email</th>
            <th>Expand</th>
          </tr>
        </thead>
        <tbody>
          <tr  v-if="skLoader" id="table_row" >
            <td colspan="17">
              <b-skeleton-wrapper >
                  <b-skeleton height="40px" ></b-skeleton>   
                  <b-skeleton height="40px"></b-skeleton>  
                  <b-skeleton height="40px"></b-skeleton>                                     
              </b-skeleton-wrapper> 
            </td>
          </tr>
          <template v-show="!skLoader" v-for="(info, key) in infos">
            <tr class="text-left" :style="{'backgroundColor': info.length == 0 ? 'gainsboro' : '' , 'pointer-events': info.length == 0 ? 'none':'auto'}">
              <!-- <td>
                <button @click="toggle(key)" class="arrow" :class="{ opened: opened.includes(key) }"
                  style="border-radius: 3px; border: none">
                  <i class="fas fa-caret-right" aria-hidden="true" v-if="!opened.includes(key)"></i>
                  <i class="fas fa-caret-down" aria-hidden="true" v-else-if="opened.includes(key)"></i>
                </button>
              </td> -->
              <td>
                <input type="checkbox"  @click="checkedMails(key, $event)" :value="key" class="check-all"
                  :id="key.replace(/[^A-Za-z]+/g, '_')"  />
              </td>
              <td class="text-left">{{ key }}</td>
              <td></td>
              <td></td>
              <td>
                <button v-if="info.length>0" @click="toggle(key)" class="arrow" :class="{ opened: opened.includes(key) }"
                  style="border-radius: 3px; border: none">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.66113 12.4307L7.99864 15.7682L11.3362 12.4307" stroke="#48a6a6" stroke-width="1.5" />
                    <path d="M11.3359 4.82324L7.99843 1.48573L4.66092 4.82324" stroke="#48a6a6" stroke-width="1.5" />
                    <line x1="-0.000976497" y1="8.53955" x2="15.9991" y2="8.53955" stroke="#48a6a6" stroke-width="1.5" />
                  </svg>
                </button>
                <button v-else @click="toggle(key)" class="arrow" :class="{ opened: opened.includes(key) }"
                  style="border-radius: 3px; border: none">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.66113 12.4307L7.99864 15.7682L11.3362 12.4307" stroke="#ababab" stroke-width="1.5" />
                    <path d="M11.3359 4.82324L7.99843 1.48573L4.66092 4.82324" stroke="#ababab" stroke-width="1.5" />
                    <line x1="-0.000976497" y1="8.53955" x2="15.9991" y2="8.53955" stroke="#ababab" stroke-width="1.5" />
                  </svg>
                </button>
                </td>
            </tr>
            <template v-if="opened.includes(key)" v-for="(data, Childkey) in info">
              <tr :key="Childkey">
     
                <td>
                  <input type="checkbox" @click="
                      checkedChildMails(key, Childkey, data, $event),
                        parentRemoveDisable(key)
                    " :value="data.email" :id="data.email" v-model="data.ischecked" class="check-all" />
                </td>
                <td class="text-left">{{ data.user_name }}</td>
                <td class="text-left">
                  <span id="role" v-show="data.role_id == '0'" class="font-weight-bold" style="color: #66b34d">
                    <span class="bullet">• </span>Admin</span>
                  <span id="role" v-show="data.role_id == '3'" class="font-weight-bold" style="color: #a682b2">
                    <span class="bullet">• </span>Manager</span>
                  <!-- <span id="role" v-if="data.role_id == '6'" class="font-weight-bold" style="color: #f19a16">
                    <span class="bullet">• </span>Driver</span>
                  <span id="role" v-if="data.role_id == '4'" class="font-weight-bold" style="color: #ef6880eb">
                    <span class="bullet">• </span>Shipping & Receiving</span> -->
                  <span id="role" v-show="data.role_id == '9'" class="font-weight-bold" style="color: #f27cf9e8">
                    <span class="bullet">• </span>Production Supervisor</span>
                    <!-- <span id="role" v-if="data.role_id == '10'" class="font-weight-bold" style="color: #598deff2">
                    <span class="bullet">• </span>Customer</span> -->
                </td>

                <!-- <td v-if="data.role_id === '0'"> <span class="bullet">• </span>Admin</span></td>
                <td v-else-if="data.role_id === '3'">Manager</td>
                <td v-else-if="data.role_id === '6'">Driver</td>
                <td v-else-if="data.role_id === '4'">Shipping and Receiving</td>
                <td v-else-if="data.role_id === '9'">Production Supervisor</td>
                <td v-else></td> -->
                <td class="text-left">{{ data.email }}</td>
                <td></td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
      <h5 style="text-align: center; margin-top:2rem;" v-if="Object.keys(this.infos).length < 1 && !skLoader">
          No Record found.
      </h5>
      </div>
     
      <br />

      <button @click="sendNotification" style="float: right" class="btn text-light bg-green-default">
        Send
      </button>
      <!-- <button @click="saveSenderfunc" style="float: right; margin-right: 5px" class="btn btn-success">
        Save Sender
      </button> -->
      </div>
    </div>
  </div>
</template>
<script>
  import TinymceEditor from "../../views/partials/tiny_mce_editor";
  import axios from "axios";
  import $ from "jquery";
  import Multiselect from "vue-multiselect";
  export default {
    components: {
      Multiselect,
      "tiny-mce-editor": TinymceEditor,
    },

    data: function () {
      return {
        formHeader: "New Notification",
        body: "",
        selectedFile: null,
        previous_image: null,
        notification_id: 0,
        subject: "",
        type: null,
        infos: null,
        emails: [],
        opened: [],
        information: [],
        selectedEmails: {},
        selected: [],
        allSelected: false,
        is_show_mail_table: false,
        onlyMail: null,
        onlyNotication: null,
        mainAndNotificaton: null,
        remove_sender_ids: [],
        select_parent_ids: [],
        selectedType: "",
        search: "",
        awaitingSearch:false,
        Regex: "&,*$/\_.*\./",
        isLoader: true,
        // isMiniLoading2: false,
        skLoader: false,
        type_filter: [
          {name:"Admin", id:"0"},
          {name:"Manager", id:"3"},
          {name:"Production Supervisor", id:"9"},
        ],
        search_type: "",
        is_edit: false,
        sel_tab: 'all',
        search_record : '',
        selectedPage: 1,
      };
    },
    computed:{
      notificationsStatus: function () {
        this.sel_tab = this.$store.getters["persist/notificationsStatus"];
        return this.sel_tab;
      },
      notificationsSearch: function () {
        this.search_record =  this.$store.getters["users/notificationsSearch"];
        return this.search_record;
      },
      currentPage: function () {
          this.selectedPage = this.$store.getters["users/currentPage"];
          return this.selectedPage;
      
      },
    },
    watch:{
      notificationsStatus: function (val) {
        this.sel_tab = val ;
        return val;
      },
      notificationsSearch: function (val) {
        this.search_record = val ;
        return val;
      },
    },
    created: function () {
      if (this.$route.params.notification !== undefined) {
        this.formHeader = "Update Notification";
         const permission = {
      headers: {
        'X-Permission': 'all_notifications_edit' 
      }
    };
        axios
          .get("/admin/users/get-notification/" + this.$route.params.notification,permission)
          .then((response) => {
            let data = response.data;
            this.body = data[0]["body"];
            this.subject = data[0]["subject"];
            this.type = data[0]["type"];
            this.previous_image = data[0]["image_path"];
            if (data[0]["notification_type"] ) {
            //   this.onlyMail = 0;
            //   this.onlyNotication = null;
            //   this.mainAndNotificaton = null;
            //   this.is_edit = true;
            // } else if (data[0]["notification_type"] == 1) {
            //   this.onlyNotication = 1;
            //   this.onlyMail = null;
            //   this.mainAndNotificaton = null;
            //   this.is_edit = true;
            // } else if (data[0]["notification_type"] == 2){
            //   this.mainAndNotificaton = 2;
            //   this.onlyNotication = null;
            //   this.onlyMail = null;
              this.onlyMail = data[0]["notification_type"] ;
              this.is_edit = true;
            }
            // this.onlyNotication = data[0]["type"];
            this.notification_id = data[0]["id"];
            $(".breadcrumb-item>span").html(data[0]["subject"]);
          });
      }
    },
    methods: {
      saveSenderfunc() {
        let user_ids = [];
        let org_ids = [];
        let remove_sender_ids = this.remove_sender_ids;
        self = this;
        if (!$.isEmptyObject(this.selectedEmails)) {
          $.each(this.selectedEmails, function (k, values) {
            $.each(values, function (k, val) {
              if (val !== undefined) {
                user_ids.push(val.master_user_id);
                org_ids.push(val.organization_id);
              }
            });
          });
        }
        if (user_ids.length > 0 || remove_sender_ids.length > 0) {
          // let loader = this.$loading.show({
          //   loader: "dots",
          // });
          this.isLoader = true;
          this.$store
            .dispatch("users/saveSender", [user_ids, org_ids, remove_sender_ids])
            .then((res) => {
              // loader.hide();
              this.isLoader = false;
              this.$toast.success(res.data.message);
            })
            .catch(() => {
              // loader.hide();
              this.isLoader = false;
              this.$toast.error('OPPS! Something went wrong here');
            });
        }
      },

      loadSenderData(values) {
        let data = {};
        let select_parent = [];
        $.each(values, function (k, val) {
          let val_array = [];
          $.each(val, function (i, v) {
            if (v.ischecked) {
              val_array.push(v);
              if (select_parent.indexOf(k) == -1) {
                select_parent.push(k);
              }
            } else {
              val_array.push(undefined);
            }
          });
          data[k] = val_array;
        });
        this.select_parent_ids = select_parent;
        this.selectedEmails = data;
      },
      parentRemoveDisable(index) {
        let id = index.replace(/[^A-Za-z]+/g, "_");
        var size = this.selectedEmails[index].filter(function (value) {
          return value !== undefined;
        }).length;

        if (this.infos[index].length == size) {
          $("#" + id).prop("checked", true);
          $("#" + id)
            .parent()
            .removeClass("parenCheckDisable");
        }
      },
      checkedMails(index, e) {
        let seletedOrg = this.infos[index];
        self = this;
        if (e.target.checked) {
          $.each(seletedOrg, function (k, val) {
            val["ischecked"] = true;
          });
          this.selectedEmails[index] = _.cloneDeep(seletedOrg);
        } else {
          $.each(seletedOrg, function (k, val) {
            val["ischecked"] = false;
            if (self.remove_sender_ids.indexOf(val["master_user_id"]) == -1) {
              self.remove_sender_ids.push(val["master_user_id"]);
            }
          });
          delete this.selectedEmails[index];
        }

        let id = index.replace(/[^A-Za-z]+/g, "_");
        $("#" + id)
          .parent()
          .removeClass("parenCheckDisable");
      },
      toggle(id) {
        const index = this.opened.indexOf(id);
        $(".example").slideToggle();
        if (index > -1) {
          this.opened.splice(index, 1);
        } else {
          this.opened.push(id);
        }
      },
      checkedChildMails(ParentIndex, ChildIndex, value, e) {
        let id = ParentIndex.replace(/[^A-Za-z]+/g, "_");
        if (this.selectedEmails[ParentIndex]) {
          $("#" + id)
            .parent()
            .addClass("parenCheckDisable");
          if (e.target.checked) {
            this.selectedEmails[ParentIndex][ChildIndex] = value;
          } else {
            this.remove_sender_ids.push(value.master_user_id);
            $("#" + id).prop("checked", false);
            delete this.selectedEmails[ParentIndex][ChildIndex];

            var size = this.selectedEmails[ParentIndex].filter(function (value) {
              return value !== undefined;
            }).length;
            if (size == 0) {
              $("#" + id)
                .parent()
                .removeClass("parenCheckDisable");
            }
          }
        } else {
          let new_data = [];
          for (var i = 0; i < this.infos[ParentIndex].length; i++) {
            if (i == ChildIndex) {
              new_data.push(value);
            } else {
              let data = undefined;
              new_data.push(data);
            }
          }
          this.selectedEmails[ParentIndex] = new_data;
          $("#" + id)
            .parent()
            .addClass("parenCheckDisable");
        }
      },
      check(e, type) {
        this.type = type;
        // if (type == 0) {
        //   this.onlyNotication = null;
        //   this.mainAndNotificaton = null;
        // } else if (type == 1) {
        //   this.onlyMail = null;
        //   this.mainAndNotificaton = null;
        // } else {
        //   this.onlyNotication = null;
        //   this.onlyMail = null;
        // }

        this.is_show_mail_table = false;
        self = this;
        if (e.target.checked) {
          if (type == 0 || type == 2) {
            this.is_show_mail_table = true;
            setTimeout(() => {
              if (this.select_parent_ids.length > 0) {
                $.each(this.select_parent_ids, function (i, v) {
                  let id = v.replace(/[^A-Za-z]+/g, "_");
                  $("#" + id)
                    .parent()
                    .addClass("parenCheckDisable");
                  self.parentRemoveDisable(v);
                });
              }
            }, 1000);
          }
        } else {
          if (type == 0 || type == 2) {
            this.is_show_mail_table = false;
          }
          this.type = null;
        }
      },

      handleFileUpload(event) {
        this.selectedFile = event.target.files[0];
        if(this.selectedFile != null)
        {
          $(".previous_image").css("display", "none");
        }
      },


      sendNotification() {
        let self = this;
        let notif_type = this.type;
        let body = "";
        let formatted_body = "";
        let selected_emails = [];
        this.emails = [];
        let strippedString = this.body.replace(/(<([^>]+)>)/gi, '');
        formatted_body = strippedString.trim();
        if (this.subject == '') {
          this.$toast.warning('Subject can not be empty.');
          return;
        }
        else if(this.selectedFile == null && this.previous_image == null)
        {
          this.$toast.warning('Image must be selected.');
          return;
        }
        else if (this.body == '' || formatted_body.length == 0) {
          this.$toast.warning('Body can not be empty.');
          return;
        }
        else if (this.type == null) {
          this.$toast.warning('Type can not be empty.');
          return;
        }
        else {
          if (this.selectedEmails) {
            $.each(this.selectedEmails, function (k, values) {
              $.each(values, function (k, val) {
                if (val !== undefined) {
                  self.emails.push(val.email);
                }
              });
            });
          }
          if(this.emails.length == 0 && !this.is_edit && (this.onlyMail == 0 || this.onlyMail == 2) ){
            this.$toast.warning('Please Select atleast One User.');
          }else{
        
            this.$store.dispatch('users/sendNotification', [this.subject, this.body, this.onlyMail, this.notification_id, this.emails, this.selectedFile])
              .then(() => {
                // send successful message
                // this.$toast.success(body);
                this.subject = '';
                this.body = '';
                this.type = '';
                this.emails = [];
                this.selectedEmails = {};
                this.selectedFile='';
                this.$router.push('/notifications');
                // window.location.reload();
                this.$store.dispatch("users/getAllnotifications", [this.currentPage,this.sel_tab,this.search_record]).then(()=>{
                  if (this.onlyMail == 0) {
                    this.$toast.success("Email will be sent to organizations shortly");
                  } else if (this.onlyMail == 1) {
                    this.$toast.success("Notification will be sent to all organizations shortly.");
                    
                  } else if (this.onlyMail == 2) {
                      if(this.is_edit && this.$route.fullPath != '/notifications/new'){
                        this.$toast.success("Notification will be sent to all organizations shortly.");
                      }else{
                        this.$toast.success("Email will be sent to all organizations shortly and Notification for Dashboard Saved ");
                      }
                    
                  }
                });
               
              })
              .catch(() => {
                this.$toast.error('OPPS! Something went wrong.');
              });
         }
        }
      },

      formateData(values) {
        let res = values;
        let org_data = {};

        for (var i = 0; i < res.length; ++i) {
          
          var obj = res[i];
          if (obj["admin_sender_notification"] == "1") {
            obj["ischecked"] = true;
          } else {
            obj["ischecked"] = false;
          }
          if (org_data[obj.organization_name] === undefined)
            org_data[obj.organization_name] = [];

          if (obj.email != null) org_data[obj.organization_name].push(obj);
        }
        return org_data;
      },
      getUsers() {
        // let loader = this.$loading.show({
        //   loader: "dots",
        // });
        this.isLoader = true;
        var limit = 0;
        axios.get("/admin/users?limit=" + limit + "&is_subscribed=1&role_id=" + "null" + "&notification=true")
          .then((response) => {
            let res = response.data.data;
            let data = this.formateData(res);
            this.infos = data;
            this.loadSenderData(data);
            this.isLoader = false;
            // loader.hide();
          });
      },

      changeType(event) {

        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.skLoader = true;
        this.infos= [];
        let type = [];
        type = event.map(({ id }) => id);
        this.search_type = type;
        setTimeout(() => {
          
        
        axios.get('/admin/users?search=' + this.search + "&limit=0&is_subscribed=1&role_id=" + type + "&notification=true")
        .then((response) => {
          let res = response.data;
          this.skLoader = false;
          let data = this.formateData(res.data);
          this.infos = data;
          this.loadSenderData(data);
          // loader.hide();
          // this.skLoader = false;
        });
      }, 300);
      this.awaitingSearch = false;
      },

      organizationSearch() {
        let loader = this.$loading.show({
          loader: "dots",
          container: this.fullPage ? null : this.$refs.formContainer,
        });
        let self = this;
        this.org_search_value =
          this.organization_search != undefined
            ? this.organization_search.organization_id
            : "";
        let users_method =
          this.$route.fullPath == "/users/master"
            ? "get_master_users_list"
            : "getOrganizationUsers";
        // this.$router.push('users?page=' + 1);
        this.$store
          .dispatch("users/" + users_method, [
            1,
            this.org_search_value,
            this.selectedType,
          ])
          .then(function () {
            loader.hide();
          });
        this.$emit("setPage", 1, this.org_search_value);
        if (this.org_search_value == "all") {
          this.selectedType = "";
        }
      },
      subscribedUsersBySearch() {
          let limit = 0;
        //    let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ,
        // });
        // var type = event.target.value;
        this.skLoader = true;
        this.infos = [];

          setTimeout(() => {
        // axios.get('/admin/users?search=' + this.search)
        axios.get('/admin/users?search=' + this.search + "&limit=0&is_subscribed=1&role_id=" + this.search_type + "&notification=true")
        .then((response) => {
          let res = response.data;
          let resultantArray = res.data;
          let newArray = [];
            $.each(res.data, function(key, value) {
              if(value['deleted_at'] == " " || value['deleted_at'] == null){
                newArray.push(value);
              }
            });
            
          resultantArray = newArray;
          this.skLoader = false;
          let data = this.formateData(resultantArray);
          this.infos = data;
          this.loadSenderData(data);
          // loader.hide();
          
        });
      this.awaitingSearch = false;
    },500);
        
        
    },
    // checkAll(e) {
    //     console.log("checkedEmails" ,this.infos,e.target.checked)
       
    //     if (e.target.checked){
    //       $('.check-all').prop('checked', true);
        
    //     }else{
    //       $('.check-all').prop('checked', false);
    //     }
    //   }, 
    },
    mounted() {
      this.getUsers();
    },
    watch: {
      $route(to, from) {
        this.formHeader = "New Notification";
        this.body = "";
        this.type = null;
        this.onlyNotication = null;
        this.notification_id = 0;
        this.selectedFile = '';
        this.subject = "";
        this.selectedEmails = {};
        $(".breadcrumb .router-link-exact-active").html("Send New");
      },
    },
  };
</script>
<style scoped>
  .tox-notification {
    display: none !important;
  }

  .arrow-btn {
    border-radius: 3px;
    border: none;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .parenCheckDisable>input {
    height: 16px;
    width: 16px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid gray;
    border-radius: 2px;
    outline: none;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    background-color: gray;
    cursor: pointer;
    position: relative;
    top: 3px;
  }

  .parenCheckDisable>input::before {
    content: "\f068";
    /* display: block; */
    text-align: center;
    color: #fff;
    position: relative;
    left: 0.2rem;
    top: -0.3rem;
    font-family: FontAwesome;
    font-size: 10px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.8s cubic-bezier(0.3, 0.5, 0.8, 1);
  }

  tr td button .arrow:hover {
    color: #48a6a6;
  }

  .fade-enter,
  .fade-leave-to {
    transform: translateX(15px);
    opacity: 0;
  }
  label{
    color: #48a6a6; 
    font-weight: 600; 
    font-size: 14px;
  }
  input[type="radio"]{
    cursor: pointer !important;
  }
  td:nth-child(1){
    width: 0.5%;
  }
  td:nth-child(2){
    width: 30%;
  }
  td:nth-child(3){
    width: 25%;
  }
  td:nth-child(4){
    width: 34.5%;
  }
  td:nth-child(5){
    width: 10%;
  }
  .set-padding{
    padding-left: 10% !important;
    padding-right: 10% !important;
  } 
  .table-width{
    width: 102% !important;
    margin-left: -1% !important;
  }

.previous_image{
  width: 150px; 
  max-height: 150px;
  object-fit: contain;
}
</style>